export default __webpack_public_path__ + "static/CenturyExpanded-Bold-7d7e32ab09cac9baf8d22b812deaabda.woff";